/**
 * Simple tooltip utility for game card titles
 */

let tooltipEl = null;
let currentTarget = null;
let showTimer = null;
let hideTimer = null;

const SHOW_DELAY = 500; // ms to wait before showing tooltip
const HIDE_DELAY = 100; // ms to wait before hiding tooltip

function createTooltip() {
  const el = document.createElement('div');
  el.className = 'tooltip';
  el.style.cssText = `
    position: fixed;
    padding: 0.4rem 0.75rem;
    background: var(--color-bg-elevated);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-md);
    color: var(--color-text);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-normal);
    white-space: normal;
    max-width: 280px;
    z-index: var(--z-tooltip);
    box-shadow: var(--shadow-lg);
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.2s ease;
    line-height: var(--line-height-normal);
  `;
  document.body.appendChild(el);
  return el;
}

function positionTooltip(target) {
  if (!tooltipEl) return;

  const rect = target.getBoundingClientRect();
  const tooltipRect = tooltipEl.getBoundingClientRect();

  let left = rect.left;
  let top = rect.bottom + 8;

  // Keep tooltip within viewport
  if (left + tooltipRect.width > window.innerWidth - 10) {
    left = window.innerWidth - tooltipRect.width - 10;
  }
  if (left < 10) {
    left = 10;
  }

  // If tooltip would go below viewport, show it above
  if (top + tooltipRect.height > window.innerHeight - 10) {
    top = rect.top - tooltipRect.height - 8;
  }

  tooltipEl.style.left = `${left}px`;
  tooltipEl.style.top = `${top}px`;
}

function showTooltip(target, text) {
  if (currentTarget === target && tooltipEl?.style.opacity === '1') return;

  clearTimeout(hideTimer);
  clearTimeout(showTimer);

  showTimer = setTimeout(() => {
    if (!tooltipEl) {
      tooltipEl = createTooltip();
    }

    tooltipEl.textContent = text;
    currentTarget = target;

    // Position before showing (to calculate correct position)
    positionTooltip(target);

    // Show with animation
    requestAnimationFrame(() => {
      tooltipEl.style.opacity = '1';
    });
  }, SHOW_DELAY);
}

function hideTooltip() {
  clearTimeout(showTimer);
  clearTimeout(hideTimer);

  hideTimer = setTimeout(() => {
    if (tooltipEl) {
      tooltipEl.style.opacity = '0';
    }
    currentTarget = null;
  }, HIDE_DELAY);
}

export function initTooltips() {
  // Handle game card titles
  document.addEventListener('mouseover', (e) => {
    const title = e.target.closest('.game-card__title[title]');
    if (!title) return;

    // Only show tooltip if text is truncated
    const isTruncated = title.scrollWidth > title.clientWidth;
    if (isTruncated && title.hasAttribute('title')) {
      showTooltip(title, title.getAttribute('title'));
    }
  });

  document.addEventListener('mouseout', (e) => {
    const title = e.target.closest('.game-card__title[title]');
    if (title) {
      hideTooltip();
    }
  });

  // Hide tooltip on scroll
  document.addEventListener('scroll', hideTooltip, { passive: true });

  // Clean up on page unload
  window.addEventListener('beforeunload', () => {
    clearTimeout(showTimer);
    clearTimeout(hideTimer);
    if (tooltipEl && tooltipEl.parentNode) {
      tooltipEl.parentNode.removeChild(tooltipEl);
    }
  });
}